const e = {
  name: "Chair",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28.2 40" style="enable-background:new 0 0 28.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,0H0l3.2,19.1V40h2V25h7v15h2V25h3v15h2V25h7v15h2V18H19L16,0z M26.2,23h-12v-3h12V23z M12.2,23h-7v-3h7
			V23z M17,18H5l-1.2-7h12L17,18z M3.5,9L2.4,2h12l1.2,7H3.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Chair
};
